import { Document, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';

type DocumentPdfLayoutProps = {
    title?: string;
    fileName?: string;
    locale?: Intl.LocalesArgument;
    children?: React.ReactNode;
};

const styles = StyleSheet.create({
    page: {
        padding: 15,
        gap: 15,
    },
    pageHeader: {
        fontSize: 15,
        textTransform: 'uppercase',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    logoContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15,
    },
    logo: {
        height: 25,
        width: 'auto',
    },
    dateText: {
        fontSize: 8,
        color: '#888',
    },
    footer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 10,
        paddingHorizontal: 10,
    },
    logoFooter: {
        height: 15,
        width: 'auto',
    },
});

const DocumentPdfLayout: React.FC<DocumentPdfLayoutProps> = ({ title, locale, fileName, children }) => {
    return (
        <Document author="SLTP" title={fileName} creationDate={new Date()} creator="SLTP" language={'fr'}>
            <Page size="A4" style={styles.page}>
                {/* Logo */}
                <View style={styles.logoContainer} fixed>
                    <Image
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                        }}
                        src={require('../../assets/images/black-pixel.png')}
                    />
                    <Image style={styles.logo} src={require('../../assets/images/logo sltp.png')} />
                </View>

                {/* Title */}
                {title && (
                    <Text style={styles.pageHeader} fixed>
                        {title}
                    </Text>
                )}

                {/* Content */}
                <View style={{ flex: 1 }}>{children}</View>

                {/* Footer */}
                <View style={styles.footer} fixed>
                    <Image style={styles.logoFooter} src={require('../../assets/images/logo-my-sltp.png')} />
                    <Text style={styles.dateText} render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`} fixed />
                    <Text style={styles.dateText}>{new Date().toLocaleDateString(locale)}</Text>
                </View>
            </Page>
        </Document>
    );
};

export default DocumentPdfLayout;
